/**
 * Vietnamese room name generator.
 *
 * Generates friendly Vietnamese-flavoured room names (without diacritics so they
 * stay URL-safe) to be used as the placeholder/suggested room name on the
 * welcome page. The words are combined following the pattern
 * NOUN + ADJECTIVE + VERB + ADVERB, e.g. "ChimXanhBayNhanh".
 */
/**
 * Danh tu (nouns).
 */
const _NOUN_ = [
    'Bien', 'Nui', 'Song', 'Suoi', 'Rung', 'Hoa', 'La', 'Cay', 'Chim', 'Ca',
    'Meo', 'Cho', 'Voi', 'SuTu', 'Gau', 'Rong', 'Phuong', 'Mua', 'Nang', 'Gio',
    'May', 'Sao', 'Trang', 'MatTroi', 'BauTroi', 'DaiDuong', 'ThacNuoc',
    'CanhDong', 'VuonHoa', 'ConDuong', 'NgoiNha', 'ThanhPho', 'LangQue',
    'HonDao', 'DongSong', 'NgonNui', 'CanhRung', 'BaiBien', 'DongCo', 'KhuVuon',
    'BongHoa', 'CanhChim', 'DanCa', 'ChuMeo', 'BayChim', 'DongSuoi', 'VungTroi',
    'AnhTrang', 'TiaNang', 'ConSong'
];
/**
 * Tinh tu (adjectives).
 */
const _ADJECTIVE_ = [
    'Xanh', 'Do', 'Vang', 'Tim', 'Hong', 'Trang', 'Den', 'Nau', 'Cam', 'Bac',
    'Vui', 'Buon', 'Hien', 'Ngoan', 'ThongMinh', 'NhanhNhen', 'ChamChi', 'To',
    'Nho', 'Cao', 'Thap', 'Dep', 'Manh', 'Yeu', 'Moi', 'Cu', 'Am', 'Mat',
    'Sang', 'Toi', 'RucRo', 'LongLanh', 'DiuDang', 'TuoiTan', 'YenBinh',
    'TrongLanh', 'BaoLa', 'MenhMong', 'HungVi', 'ThoMong'
];
/**
 * Dong tu (verbs).
 */
const _VERB_ = [
    'Bay', 'Chay', 'Nhay', 'Boi', 'Hat', 'Nhun', 'Cuoi', 'Reo', 'Ngam', 'Choi',
    'Hoc', 'Lam', 'Di', 'Ve', 'Toa', 'Roi', 'No', 'Moc', 'Lan', 'Troi',
    'Vuon', 'Hot', 'Goi', 'Vang', 'NgamNhin', 'ToaSang', 'VuonMinh', 'NgaoDu',
    'DaoChoi', 'KhamPha'
];
/**
 * Trang tu (adverbs).
 */
const _ADVERB_ = [
    'Nhanh', 'Cham', 'Nhe', 'Manh', 'Khe', 'Vui', 'Lang', 'Em', 'DiuDang',
    'NhipNhang', 'RonRang', 'ThanhThoi', 'TungBung', 'NaoNhiet', 'LungLinh',
    'RucRo', 'KhongNgung', 'MaiMai', 'BatTan', 'HomNay', 'MoiNgay', 'Som',
    'Muon', 'CuoiCung', 'TuTon'
];
/**
 * Returns a random element of the provided array.
 *
 * @param {Array<string>} arr - The source array.
 * @returns {string} A random element of the array.
 */
function randomElement(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
/**
 * Generates a new Vietnamese room name.
 *
 * @returns {string} A newly-generated room name.
 */
export function generateRoomWithoutSeparator() {
    return randomElement(_NOUN_)
        + randomElement(_ADJECTIVE_)
        + randomElement(_VERB_)
        + randomElement(_ADVERB_);
}
